<template>
<div class="maskMember">
    <div class="member">
        <!-- login -->
        <div class="box login active">
            <h1 class="title" i18n="login_title">Log in to Tipard</h1>
            <div class="email_box input_box">
                <input class="email" type="text" i18n_input="email_placeholder" placeholder="Email">
                <p></p>
            </div>
            <div class="password_box input_box">
                <input class="password" type="password" i18n_input="password_placeholder" placeholder="Password" autocomplete="off">
                <p></p>
                <div>
                  <img src="https://account.tipard.com/images/hide.svg" rel="nofollow" i18n_title="hide_password" title="Hide password" loading="lazy" alt="Hide">
                  <img src="https://account.tipard.com/images/show.svg" rel="nofollow" i18n_title="show_password" title="Show password" loading="lazy" alt="Show">
                </div>
            </div>
            <p class="forgot_password"><a class="forgot_password_a" i18n='forgot_password'>Forgot password?</a></p>
            <span class="btn login_btn"><span i18n="log_in">Log In</span><img src="https://account.tipard.com/images/loading.svg" rel="nofollow" alt="Loading"><p></p></span>
            <p class="create_account"><span i18n="no_account">No account?</span> <a class="create_it" i18n="create_it">Create it</a></p>
            <div class="third_party">
                <p class="flex_box"><span i18n='or_log_in_with'>Or log in with</span></p>
                <div class="flex_box">
                  <div class="google_a"><img src="https://account.tipard.com/images/google-btn.svg" rel="nofollow" alt="Google"><span i18n="google_login">Sign in with Google</span></div>
                    <a class="passwordless_login"><img src="https://account.tipard.com/images/passwordless.svg" rel="nofollow" alt="Passwordless"><span i18n="passwordless_login">Passwordless login</span></a>
                </div>
            </div>
        </div>
        <!-- passless_login -->
        <div class="box passless_login">
            <h1 class="title" i18n="passwordless_login">Passwordless Login</h1>
            <p class="subtitle" i18n="password_login_subtitle">Passwordless login with email</p>
            <div class="email_box input_box">
                <input class="email" value="" type="text" i18n_input="email_placeholder" placeholder="Email">
                <p></p>
            </div>
            <div class="code_box flex_box input_box">
                <input class="code" type="text" i18n_input="code_placeholder" placeholder="Verification Code" readonly="true">
                <span class="getcode" i18n="Get">Get</span>
                <p></p>
            </div>
            <span class="btn passless_login_btn"><span i18n="log_in">Log In</span><img src="https://account.tipard.com/images/loading.svg" rel="nofollow" alt="Loading"><p></p></span>
            <div class="third_party">
                <p class="flex_box"><span i18n="or_log_in_with">Or log in with</span></p>
                <div class="flex_box">
                  <div class="google_a"><img src="https://account.tipard.com/images/google-btn.svg" rel="nofollow" alt="Google"><span i18n="google_login">Sign in with Google</span></div>
                    <a class="passwordless_login back_to_log_in"><img src="https://account.tipard.com/images/my.svg" rel="nofollow" alt="My"><span i18n="account_login">Account Login</span></a>
                </div>
            </div>
            <p class="create_account"><span i18n="no_account">No account?</span> <a class="create_it" i18n="create_it">Create it</a></p>
            <p class="rights" i18n="rights">By creating this account, you agree with to <a href="https://www.tipard.com/terms.html">Terms of Service</a> and  <a href="https://www.tipard.com/policy.html">Privacy Policy</a></p>
        </div>
        <!-- register -->
        <div class="box register">
            <h1 class="title" i18n="sign_up">Sign Up</h1>
            <p class="subtitle" i18n="register_info">Create your account</p>
            <div class="email_box input_box">
                <input class="email" value="" type="text" i18n_input="email_placeholder" placeholder="Email">
                <p></p>
            </div>
            <div class="password_box input_box">
                <input class="password" type="password" i18n_input="password_placeholder_1" placeholder="Create your password" autocomplete="off">
                <p></p>
            </div>
            <span class="btn register_btn"><span i18n="sign_up">Sign Up</span><img src="https://account.tipard.com/images/loading.svg" rel="nofollow" alt="Loading"><p></p></span>
            <div class="third_party">
              <p class="flex_box"><span i18n='or_log_in_with'>Or log in with</span></p>
              <div class="flex_box">
                <div class="google_a"><img src="https://account.tipard.com/images/google-btn.svg" rel="nofollow" alt="Google"><span i18n="google_login">Sign in with Google</span></div>
                <a class="passwordless_login"><img src="https://account.tipard.com/images/passwordless.svg" rel="nofollow" alt="Passwordless"><span i18n="passwordless_login">Passwordless login</span></a>
              </div>
            </div>
            <p class="back">
              <a class="back_to_log_in" i18n="back_to_log_in">Back to log in</a>
            </p>
            <p class="rights" i18n="rights">By creating this account, you agree with to <a href="https://www.tipard.com/terms.html">Terms of Service</a> and  <a href="https://www.tipard.com/policy.html">Privacy Policy</a></p>
        </div>
        <!-- registration-succeeded -->
        <div class="box third_party_success success registration_succeeded">
            <h1 class="title" i18n="registration_succeeded">Registration Succeeded</h1>
            <img src="https://account.tipard.com/images/succes.svg" rel="nofollow" loading="lazy" alt="Succes">
            <p class="info" i18n="registration_succeeded_info_1">Congratulations! You have registered successfully. We have sent the verification message to your email <span class="email"></span>, and please finish verifying to use the benefits of this email.</p>
            <p class="info" style="display: none;" i18n="registration_succeeded_info_2">Click "Finish" to return to the Home page and use this product.</p>
            <p class="info operation" style="display: none;" i18n="registration_succeeded_info_3">Click "Finish" to close the current page and return to the Home page for the following operations. If closing fails, please manually close the tab.</p>
            <span class="btn done"><span i18n="Done">Done</span><p></p></span>
        </div>
        <!-- 3rd-login-merge-account -->
        <div class="box third_party_registered success">
            <h1 class="title" i18n="login_title">Log in to Tipard</h1>
            <img src="https://account.tipard.com/images/doubt.svg" rel="nofollow" loading="lazy" alt="DDoubt">
            <p class="info" style="max-width: 320px;" i18n="three_rd_login_merge_account">The third-party account email address has been signed up, do you want to connect and log in with this email address directly?</p>
            <div class="input_box">
              <span class="third_party_registered_btn btn" i18n="connect_log_in">Connect & Log In</span>
              <p style="text-align: center;width: 100%;"></p>
            </div>
            <div class="third_party_registered_register">
              <span i18n="create_an_account">Create an account</span>
              <p></p>
            </div>
        </div>
        <!-- reset_login -->
        <div class="box reset">
            <h1 class="title" i18n="forgot_password">Forgot Password</h1>
            <p class="subtitle" i18n="reset_password_subtitle">Use your account email to reset password</p>
            <div class="email_box input_box">
                <input class="email" value="" type="text" i18n_input="email_placeholder" placeholder="Email">
                <p></p>
            </div>
            <div class="code_box flex_box input_box">
                <input class="code" type="text" i18n_input="code_placeholder" placeholder="Verification Code" readonly="true">
                <span class="getcode" i18n="Get">Get</span>
                <p></p>
            </div>
            <div class="password_box input_box">
                <input class="password" type="password" i18n_input="password_placeholder_3" placeholder="Create new password" autocomplete="off">
                <p></p>
            </div>
            <div class="password_box input_box">
                <input class="password copy_password" type="password" i18n_input="password_placeholder_4" placeholder="Confirm new password" autocomplete="off" onpaste="return false">
                <p></p>
            </div>
            <span class="btn reset_btn"><span i18n="reset_now">Reset Now</span><p></p></span>
            <p style="margin-top: 20px;text-align: center;"><a class="back_to_log_in" i18n="back_to_log_in">Back to log in</a></p>
        </div>
        <i class="close"></i>
    </div>
    <i class="close"></i>
</div>
</template>

<script>
import Japp from "@/assets/js/app"
export default {
    mounted(){
        $.getScript(officeUrl+'js/unique.js',function(){
            $.getScript(accountHref+"js/i18n.js",function(){
                const oScript = document.createElement('script');
                oScript.type = 'text/javascript';
                oScript.src = accountHref+'js/mask-member.js';
                document.body.appendChild(oScript);
                oScript.onload = function() {
                    $('#feedback').unbind();
                    $("#form_submit").click(function(e){
                        e.stopPropagation();
                        if(!isnetwork()){return false;};
                        var mail = $.trim($('#feedback #mail').val());
                        if ($('#feedback #mail').val() == '') {
                            $('#feedback #mail').next().html(i18n[lang].email_empty);
                            return false;
                        }
                        if (!reg_email.test(mail)) {
                            $('#feedback #mail').next().html(i18n[lang].email_not_valid_2);
                            return false;
                        }
                        if ($('#feedback #form_contents').val() == '') {
                            $('#feedback #form_contents').next().html(i18n[lang].form_contents);
                            return false;
                        }
                        var data = { f_source: '3', product_id: Japp.product_id, email: '', content: '' };
                        data['email'] = $('#feedback #mail').val();
                        data['content'] = $('#feedback #form_contents').val();
                        $('#feedback #mail').val('');
                        $('#feedback #form_contents').val('');
                        $('.info_form').fadeIn().delay(2000).fadeOut();
                        console.log(data);
                        $.ajax({
                            url: 'https://support.tipard.com/api/feedback/v1/index.php',
                            type: 'post',
                            data: data,
                        });
                        $('#feedback').css({ display: 'none' });
                    })

                    $('.feed-back-link').click(function () {
                        $('.feedback').show()
                    })
                }
            })
        })

        $('.maskMember .close').click(function(){
            $('.maskMember').hide();
        });
        window.logOutFn=function(){
            $('.header .login ul').hide();
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            setCookie("user","",-1)
            $.post(
                post_url+'account/logout',
                {
                    e_id:user.e_id,
                    t_id:user.t_id,
                    token:user.token
                },
                function(data){
                    console.log(data);
                }
            )
            user="";
        }
        // 初始头像路径
        window.oldImgUrl=$('.header .right .login img').attr('src');

    }
}
</script>

<style scoped>
    @import "https://account.tipard.com/css/mask-member.css";
    .maskMember{position: fixed;z-index: 999;top: 0px;left: 0px;width: 100%;height: 100%;background: rgba(0, 0, 0, .2);display: none;}
    .member .passless_login .rights{margin-top: 35px;}
    @media screen and (max-width:980px){
        .maskMember{
            background: #fff;
        }
        .member>.close{
            display: none;
        }
        .maskMember>.close{
            position: absolute;
            right: 14px;
            top: 14px;
            width: 19px;
            height: 19px;
            cursor: pointer;
            z-index: 2;
            background: url(../assets/images/close-m.svg);
        }
    }
</style>